<template>
  <canvas :width="width" :height="height" :id="id"></canvas>
</template>

<script>
import Chart from "chart.js";
export default {
  props: ["id", "width", "height", "type", "title", "labels", "data"],
  mounted() {
    var ctx = document.getElementById(this.id).getContext("2d");
    new Chart(ctx, {
      type: this.type ? this.type : "bar",
      data: {
        labels: this.labels,
        datasets: [
          {
            label: this.title,
            data: this.data,
            backgroundColor: [
              "rgb(255, 99, 132)",
              "rgb(255, 159, 64)",
              "rgb(255, 205, 86)",
              "rgb(75, 192, 192)",
              "rgb(54, 162, 235)",
            ],
            borderWidth: 10,
            borderColor: "#ffffff",
            hoverBorderColor: "#ffffff",
          },
        ],
      },
      options: {
        responsive: true,
        cutoutPercentage: 25,
        legend: {
          position: "right",
          align: "center",
        },
        animation: {
          animateScale: true,
          animateRotate: true,
        },
        tooltips: {
          enabled: true,
        },
      },
    });
  },
};
</script>
